import emptyStateSvg from '@gitlab/svgs/dist/illustrations/empty-state/empty-issues-add-md.svg';
import jiraCloudAppLogo from '@gitlab/svgs/dist/illustrations/third-party-logos/integrations-logos/jira_cloud_app.svg?raw';
import { GlButton, GlEmptyState, GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { helpPagePath } from '~/helpers/help_page_helper';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { s__ } from '~/locale';
import { isLoggedIn } from '~/lib/utils/common_utils';
export default {
    name: 'EmptyState',
    i18n: {
        title: s__('WorkItem|Track bugs, plan features, and organize your efforts with work items'),
        description: s__('WorkItem|Use work items (also known as tickets or stories on other platforms) to collaborate on ideas, solve problems, and plan your project.'),
        descriptionWithoutProjects: s__('WorkItem|Use epics to collaborate on ideas, solve problems, and plan work across this group. To track other work items, create a project.')
    },
    emptyStateSvg,
    issuesHelpPagePath: helpPagePath('user/project/issues/_index'),
    jiraIntegrationPath: helpPagePath('integration/jira/_index'),
    components: {
        GlButton,
        GlEmptyState,
        GlLink
    },
    directives: {
        SafeHtml
    },
    inject: [
        'canCreateProjects',
        'newIssuePath',
        'newProjectPath',
        'showNewIssueLink',
        'signInPath',
        'isGroup'
    ],
    props: {
        hasProjects: {
            type: Boolean,
            required: false,
            default: false
        },
        hasEpicsFeature: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            isLoggedIn: isLoggedIn()
        };
    },
    computed: {
        showNewProjectButton () {
            return this.canCreateProjects && this.isGroup && !this.hasProjects;
        },
        description () {
            return this.showNewProjectButton && this.hasEpicsFeature ? this.$options.i18n.descriptionWithoutProjects : this.$options.i18n.description;
        },
        newProjectButtonVariant () {
            // Without epics there is no "New item" button, so "New project" is the only action
            return this.hasEpicsFeature ? 'default' : 'confirm';
        }
    },
    jiraCloudAppLogo
};
